export default function genererCritereRechercheProduitReseauNumerique() {
  const values = {
    auto: '',
    actif: true,
    societeId: null,
    reference: null,
    villes: [],
    departements: [],
    formats: [],
    typeReseauIds: [],
    libelle: null,
    dateVisualisation: new Date(),
    agencesId: [],
    materiels: [],
    codesPostaux: [],
    supports: [],
  };
  return values;
}
